<template>
  <div class="confetti-input">
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label class="confetti-input-container">
      <div
        class="confetti-input-input"
        :tabindex="tabindex"
        :data-input="dataInput"
        @click="isActive = true"
        @keyup.enter="isActive = true"
        @focus="handleFocus"
      >
        <div v-show="showInputs" class="confetti-fraction-wrapper">
          <input
            ref="numerator"
            :value="numerator"
            type="number"
            class="confetti-fraction__input confetti-fraction__input--numerator"
            min="1"
            placeholder="00"
            @input="($event) => resizeInput($event.target)"
            @blur="($event) => handleNumeratorChange($event.target.value)"
            @keydown="handleKeydown"
            @keyup="handleKeyup"
          />
          <div class="confetti-fraction__separator">/</div>
          <input
            ref="denominator"
            :value="denominator"
            type="number"
            class="confetti-fraction__input confetti-fraction__input--denominator"
            min="2"
            placeholder="00"
            @input="($event) => resizeInput($event.target)"
            @blur="($event) => handleDenominatorChange($event.target.value)"
            @keydown="handleKeydown"
            @keyup="handleKeyup"
          />
        </div>
      </div>
      <span v-if="label" class="confetti-input-label">{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "ConfettiFractionInput",
  props: {
    label: {
      type: String,
      default: null,
    },
    numerator: {
      type: Number,
      default: null,
    },
    denominator: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      tabindex: 0,
      isActive: false,
    };
  },
  computed: {
    dataInput() {
      const value = this.numerator || this.denominator || "";

      return value;
    },
    showInputs() {
      const state =
        this.numerator || this.denominator || this.isActive || !this.label;

      return state;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickAway);
    document.addEventListener("focusout", this.handleFocusOut);

    this.resizeInput(this.$refs.numerator);
    this.resizeInput(this.$refs.denominator);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickAway);
    document.removeEventListener("focusout", this.handleFocusOut);
  },
  methods: {
    async handleFocus() {
      this.isActive = true;

      await this.$nextTick();

      this.$refs.numerator.focus();
      this.tabindex = -1;
    },
    handleNumeratorChange(value) {
      this.$emit("numeratorChange", parseInt(value) || null);
    },
    handleDenominatorChange(value) {
      this.$emit("denominatorChange", parseInt(value) || null);
    },
    resizeInput(target) {
      const value = target.value;

      if (value) {
        target.style.width = `${value.length}ch`;
      } else {
        target.style.width = "2ch";
      }
    },
    handleClickAway({ target }) {
      if (!this.$el.contains(target)) {
        this.isActive = false;
      }
    },
    handleFocusOut({ relatedTarget }) {
      if (!this.$el.contains(relatedTarget)) {
        this.isActive = false;
        this.tabindex = 0;
      }
    },
    handleKeydown($event) {
      if ($event.code === "Comma" || $event.code === "Period") {
        $event.preventDefault();
      }
    },
    handleKeyup($event) {
      if ($event.code === "Slash") {
        this.$refs.denominator.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* stylelint-disable no-descending-specificity */

.confetti-fraction-wrapper {
  cursor: text;
  display: flex;
}

.confetti-fraction__input::-webkit-outer-spin-button,
.confetti-fraction__input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.confetti-fraction__input {
  appearance: textfield;
  border: none;
  font-family: inherit;
  font-size: 1.4rem;
  inline-size: 2ch;
  padding: 0;

  &:focus {
    outline: none;
  }
}

.confetti-fraction__separator {
  margin-block: 0;
  margin-inline: 4px;
}

.confetti-input-label {
  pointer-events: none;
}
</style>
